export default __webpack_public_path__ + "logo_tdc_night.d3be0e4.svg";